import React from 'react';
import { Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  open: boolean;
  src: string | null;
  alt: string;
  onClose: () => void;
}

function OnSiteImageLightbox({ open, src, alt, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <Box sx={{ position: 'relative', backgroundColor: '#000' }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: '#fff',
            backgroundColor: 'rgba(0,0,0,0.4)',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' }
          }}
        >
          <CloseIcon />
        </IconButton>
        {src && (
          <Box
            component="img"
            src={src}
            alt={alt}
            onClick={onClose}
            sx={{
              display: 'block',
              maxWidth: '100%',
              maxHeight: '85vh',
              margin: '0 auto',
              cursor: 'zoom-out'
            }}
          />
        )}
      </Box>
    </Dialog>
  );
}

export default OnSiteImageLightbox;
